/**
 * GraphQL authentication helpers
 */

import { getGraphQLAuthEndpoint } from './endpoints';

interface GraphQLSignInResponse {
  meta?: {
    token?: string;
  };
}

export async function signInAdminUser(email: string, password: string): Promise<string> {
  const response = await fetch(getGraphQLAuthEndpoint(), {
    method: 'POST',
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
    body: JSON.stringify({
      data: {
        type: 'admin-user',
        attributes: {
          email,
          password,
        },
      },
    }),
  });

  let json: GraphQLSignInResponse | null = null;
  try {
    json = (await response.json()) as GraphQLSignInResponse;
  } catch (e) {
    json = null;
  }

  if (!response.ok) {
    const message =
      (json as any)?.errors?.[0]?.detail ||
      (json as any)?.message ||
      `GraphQL sign-in failed with status ${response.status}`;
    throw new Error(message);
  }

  const token = json?.meta?.token;
  if (!token) {
    throw new Error('GraphQL sign-in response missing token');
  }

  return token;
}
